// src/pages/cashier/AfricanEOD.jsx
import React from 'react';
import EndOfDay from '../EndOfDay';

const AfricanEOD = () => {
  return <EndOfDay locationKey="african" />;
};

export default AfricanEOD;